var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"max-height":"100px"}},[_c('v-alert',{staticClass:"mx-2 mt-4",attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v(" به زودی ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }